import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function ShanieceHunterPage() {
  return <AttorneyBioTemplate attorney={attorneys['shaniece-hunter-esq']} />;
}
